// extracted by mini-css-extract-plugin
module.exports = {"video":"_2ln--Zsop8Swpn7JZ16ks6","image":"ZMxw7GGJv29edjMTGD9vf"};